import React from 'react'
import { Procedure } from '@dataTypes/claimFeature.types'
import ActionButtons from '@components/common/ActionButtons/ActionButtons.component'
import { getAttachmentType } from '@utils/claims.util'
import { TooltipComponent } from '@syncfusion/ej2-react-popups'

export const getProcedureColumns = (
  handleDeleteProcedure: (procedureId: string) => void,
  handleEditProcedure: (procedure: Procedure, editMode: boolean) => void,
  handleUpdateClinicFee: (
    procedureId: string,
    newFee: string,
    selectedFeeKey: string,
    phaseName?: string,
  ) => void,
  attachmentRequirements: any,
  claimSource: 0 | 1,
): Array<{
  field: string
  headerText: string
  template?: (rowData: Procedure) => JSX.Element
  width: string
  headerStyle?: React.CSSProperties
}> => {
  return [
    ...(claimSource === 1
      ? [
          {
            field: 'phaseName',
            headerText: 'Phase',
            width: '40',
          },
        ]
      : []),
    {
      field: 'procedureName',
      headerText: 'Procedure',
      template: (rowData: Procedure) => {
        let isReqCompleted = true
        const requirements =
          attachmentRequirements?.requirements.filter(
            (requirement: any) =>
              requirement.procedureCode === rowData.procedureCode,
          ) || []
        if (requirements.length > 0 && requirements[0].required) {
          Object.keys(requirements[0].required).forEach((key) => {
            if (requirements[0].required[key] === true) {
              if (
                rowData.procedureAttachments.find(
                  (attachment: any) =>
                    attachment.attachmentType === getAttachmentType(key),
                ) !== undefined
              ) {
                console.log('key', key)
              } else {
                isReqCompleted = false
              }
            }
          })
        }
        return (
          <div style={{ whiteSpace: 'normal' }}>
            <div className="procedure-cell d-flex align-items-center">
              <span
                className={`icon ${isReqCompleted ? 'mgc_save_line procedure-attachment-complete-icon' : 'mgc_file_warning_line procedure-attachment-incomplete-icon'}`}
              ></span>
              <span className="mx-1">{rowData.procedureCode}</span>
              <TooltipComponent
                content={rowData.procedureName}
                opensOn="Hover"
                cssClass="e-tooltip-template-css e-tooltip-tab-feature"
                position="TopCenter"
              >
                <span className="icon mgc_information_fill procedure-info-icon"></span>
              </TooltipComponent>
            </div>
          </div>
        )
      },
      width: '100',
      headerStyle: { textAlign: 'center' },
    },
    {
      field: 'procedureDate',
      headerText: 'Procedure date',
      width: '180',
    },
    {
      field: 'siteRegion',
      headerText: 'T/S',
      width: '180',
      headerStyle: { textAlign: 'center' },
      template: (data: Procedure) => {
        return (
          <span style={{ whiteSpace: 'normal' }}>{data.siteRegion || '-'}</span>
        )
      },
    },
    {
      field: 'amount',
      headerText: 'Claim amt.',
      width: 'auto',
      headerStyle: { textAlign: 'center' },
      template: (rowData: Procedure) => {
        return <span>${parseFloat(rowData.amount).toFixed(2)}</span>
      },
    },
    {
      field: 'actions',
      headerText: 'Actions',
      headerStyle: { textAlign: 'center' },
      template: (rowData: Procedure) => (
        <ActionButtons
          onView={() => handleEditProcedure(rowData, false)}
          onEdit={() => handleEditProcedure(rowData, true)}
          onDelete={() => handleDeleteProcedure(rowData.procedureId)}
          showMoreOptions={false}
        />
      ),
      width: '110',
    },
  ]
}
